module.exports = __webpack_public_path__ + "img/subscriptions.05e85ef6.svg";